export default __webpack_public_path__ + "static/slider-banner-2-dbeb064b2b4f6a6441b83e656910da39.png";